import cn from 'classnames/bind'
import SceletonItem from 'app/common/templates-next/page-template/skeleton-item'
import RenderValue from './render-value'

import styles from './summary-item.module.scss'


const cx = cn.bind(styles)
const skeletonStyle = { height: '46px' }
const skeletonStyleTitle = { height: '20px' }

type Props = {
  className?: string
  title: string
  value: string | Array<string>
  pending?: boolean
  danger?: boolean
  valueColor?: 'accepted' | 'refused' | 'waiting'
}

const SummaryItem = ({ title, value, pending, className, danger, valueColor }: Props) => {

  return (
    <div>
      <div className={cx(styles.root, { danger }, className)}>
        {!title && pending
          ? <SceletonItem style={skeletonStyleTitle} />
          : <div className={styles.title}>{title}</div>}
        {pending
          ? <SceletonItem style={skeletonStyle} />
          : <RenderValue value={value} valueColor={valueColor} />}
      </div>
    </div>
  )
}

export default SummaryItem
